import React, { useContext, useState } from 'react'
import "./loginPage.css";
import cover_photo from './cover_photo.png';
import { login, forgot } from '../../Controllers/Auth'
import { useNavigate } from 'react-router-dom';
import { __constants, __snackBarSeverity, __snackBarText } from '../../constants';
import { UnstyledButton } from '../../common_components/Button';
import mainContext from '../../contexts/mainContext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton } from '@mui/material';
import logo from './logo_grey.svg'
import { objectValidate } from '../../Helpers/validation';

const LoginPage = (props) => {
    const { getAdminProfile } = props;
    const { setSnackBar } = useContext(mainContext);
    const navigate = useNavigate();
    const [sectionToShow, setSectionToShow] = useState("login");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [showEye, setShowEye] = useState(true);
    const [state, setState] = useState({ email: "" })


    const handleForgot = async () => {
        const forgot_email = document.getElementById("forgot_email").value;
        const data = {
            email: forgot_email
        }

        let vald = objectValidate(data)
        if (!vald.isValid) {
            return setSnackBar({
                status: true,
                text: vald.msg,
                severity: __snackBarSeverity.error
            })
        }
        setButtonLoader(true);
        setState({ ...state, email: data.email })
        const res = await forgot(data);
        if (res && res.status === 500) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message || __snackBarText.unKnownError,
                severity: __snackBarSeverity.error
            })
        }
        setButtonLoader(false);
        setSectionToShow("sendMail")
    }

    const handleLogin = async () => {
        const email = document.getElementById("email").value;
        const password = document.getElementById("password").value;
        const data = {
            email,
            password
        }

        let vald = objectValidate(data)
        if (!vald.isValid) {
            return setSnackBar({
                status: true,
                text: vald.msg,
                severity: __snackBarSeverity.error
            })
        }
        setButtonLoader(true);
        const res = await login(data);
        if (res && res.status === 500) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: __snackBarText.internalServerError,
                severity: __snackBarSeverity.error
            })
        }
        if (res.data.status !== 200) {
            setButtonLoader(false);
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message || __snackBarText.unKnownError,
                severity: __snackBarSeverity.error
            })
        }

        localStorage.setItem(__constants.authToken, res.data.data.token);
        setButtonLoader(false);
        getAdminProfile(res.data.data.token);
        navigate("/");
    }

    return (
        <div className="login_page_main_div">
            <div className="left_section">
                <div className="login_section">
                    <div className="logo">
                        <div className='img_div'>
                            <img src={logo} alt="" />
                        </div>
                        <h4>ADMIN PANEL</h4>
                    </div>
                    <div className="login_text">
                        {
                            sectionToShow === "login" &&
                            <>
                                <h3 style={{ marginBottom: "6px" }}>Welcome !</h3>
                                <p>Enter your email address & password to access the nona admin panel</p>
                            </>
                        }
                        {
                            sectionToShow === "forgot" &&
                            <>
                                <h3 style={{ marginBottom: "6px" }}>Forgot password</h3>
                                <p>Enter your registered email address and follow the instructions</p>
                            </>
                        }
                        {
                            sectionToShow === "sendMail" &&
                            <>
                                <h3 style={{ marginBottom: "6px" }}>Forgot password</h3>
                                <p>Enter your registered email address and follow the instructions</p>
                            </>
                        }
                    </div>
                    <div className="login_form">
                        {
                            sectionToShow === "login" &&
                            <>

                                <div className="input-field">
                                    <label htmlFor="email">Email Address</label>
                                    <input maxLength={40} type="email" id="email" placeholder="Enter Mail" />
                                </div>
                                <div className="input-field">
                                    <label htmlFor="password">Password</label>
                                    <input maxLength={30} type={showEye ? "password" : "text"} id='password' placeholder="Enter Password" />

                                    <div className="login-show-password">
                                        {
                                            showEye ?
                                                <IconButton
                                                    onClick={() => { setShowEye(!showEye) }}
                                                    size="small">
                                                    <VisibilityOffIcon />
                                                </IconButton>
                                                :
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setShowEye(!showEye)
                                                    }}
                                                >
                                                    <VisibilityIcon />
                                                </IconButton>}

                                    </div>
                                </div>
                                <div className="login_forgot_section">
                                    Forgot Password? <span className='for-redirection' onClick={() => { setSectionToShow("forgot") }}>Click here to reset</span>
                                </div>
                                <div
                                    className="login_btn"
                                    style={{
                                        color: !buttonLoader && "white",
                                        // backgroundColor: !buttonLoader && "var(--theme-color)",
                                        backgroundColor: !buttonLoader && "var(--nona-theme-color)",
                                    }}
                                >
                                    <UnstyledButton
                                        loading={buttonLoader}
                                        text="Login"
                                        onClick={handleLogin}
                                    />
                                </div>
                            </>
                        }
                        {
                            sectionToShow === "forgot" &&
                            <>
                                <label htmlFor="forgot_email">Registered Email Address</label>
                                <input maxLength={40} type="email" id="forgot_email" placeholder="Enter Mail" />
                                <div className="login_forgot_section">
                                    Didn't forgot? <span className='for-redirection' onClick={() => { setSectionToShow("login") }}>Click here to login</span>
                                </div>
                                <div
                                    className="request_btn"
                                    style={{
                                        color: !buttonLoader && "white",
                                        // backgroundColor: !buttonLoader && "var(--theme-color)",
                                        backgroundColor: !buttonLoader && "var(--nona-theme-color)",
                                    }}
                                >
                                    <UnstyledButton
                                        loading={buttonLoader}
                                        onClick={handleForgot}
                                        text="Request password change"
                                    />
                                </div>
                            </>
                        }
                        {
                            sectionToShow === "sendMail" &&
                            <>
                                <div className="send_mail_notice">
                                    We have send a eamil to {state.email}.
                                    Please verify your email and follow the reset link.
                                </div>
                                <div className="login_donot_forgot_section">
                                    Didn't forgot? <span className='for-redirection' onClick={() => { setSectionToShow("login") }}>Click here to login</span>
                                </div>
                                {/* onClick={() => { setSectionToShow("sendMail") }} */}
                                <div
                                    className="request_btn"
                                    style={{
                                        color: "white",
                                        // backgroundColor: "var(--theme-color)",
                                        backgroundColor: "var(--nona-theme-color)",
                                    }}
                                >
                                    <UnstyledButton
                                        loading={buttonLoader}
                                        onClick={() => { setSectionToShow("forgot") }}
                                        text="Wrong email? Change here"
                                    />
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className="right_section">
                <img src={cover_photo} alt="" />
            </div>
        </div>
    )
}

export default LoginPage
